// extracted by mini-css-extract-plugin
module.exports = {"identificationChooser":"IdentificationChooser_identificationChooser__2jU2Z","listButtons":"IdentificationChooser_listButtons__1WS68"};